import React, { useState } from 'react';
import { FaInstagram, FaYoutube, FaFacebookF, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { X } from 'lucide-react';

const SocialMediaBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {!isExpanded ? (
        // Collapsed - Enhanced Bouncing Round Follow Button
        <button
          onClick={() => setIsExpanded(true)}
          className="relative w-20 h-20 bg-gradient-to-br from-yellow-400 via-pink-500 to-pink-600 hover:from-yellow-500 hover:via-pink-600 hover:to-pink-700 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center animate-bounce hover:animate-none group"
        >
          <div className="text-center">
            <span className="text-xs font-extrabold block leading-tight group-hover:scale-110 transition-transform drop-shadow-lg">
              CLICK HERE
            </span>
            <span className="text-xs font-extrabold block leading-tight group-hover:scale-110 transition-transform drop-shadow-lg">
              TO FOLLOW
            </span>
          </div>
          
          {/* Sparkle effect on hover */}
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-white rounded-full opacity-0 group-hover:opacity-100 animate-ping"></div>
        </button>
      ) : (
        // Expanded - Social Icons (Vertical Stack) - Grey Gradient
        <div className="relative bg-gradient-to-br from-gray-700/95 to-gray-900/95 backdrop-blur-md rounded-2xl px-4 py-6 shadow-2xl border border-gray-500/30 animate-fadeIn">
          {/* Close Button */}
          <button
            onClick={() => setIsExpanded(false)}
            className="absolute -top-3 -right-3 bg-red-500 hover:bg-red-600 text-white rounded-full p-2 shadow-lg transition-all duration-300 hover:scale-110 z-10"
          >
            <X size={18} />
          </button>

          <div className="flex flex-col gap-4 pt-2">
            {/* Instagram */}
            <button
              onClick={() => handleSocialClick('https://instagram.com/tncoopdept')}
              className="group relative w-12 h-12 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-xl flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
              title="Instagram"
            >
              <FaInstagram className="text-white text-xl transition-transform duration-300 group-hover:scale-110" />
            </button>

            {/* YouTube */}
            <button
              onClick={() => handleSocialClick('https://www.youtube.com/@tncoopdept')}
              className="group relative w-12 h-12 bg-gradient-to-br from-red-500 to-red-700 rounded-xl flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
              title="YouTube"
            >
              <FaYoutube className="text-white text-xl transition-transform duration-300 group-hover:scale-110" />
            </button>

            {/* Facebook */}
            <button
              onClick={() => handleSocialClick('https://facebook.com/profile.php?id=100093222344544')}
              className="group relative w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
              title="Facebook"
            >
              <FaFacebookF className="text-white text-xl transition-transform duration-300 group-hover:scale-110" />
            </button>

            {/* Twitter/X */}
            <button
              onClick={() => handleSocialClick('https://x.com/TNCOOPDEPT')}
              className="group relative w-12 h-12 bg-gradient-to-br from-gray-800 to-black rounded-xl flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
              title="Twitter/X"
            >
              <FaTwitter className="text-white text-xl transition-transform duration-300 group-hover:scale-110" />
            </button>

  {/* WhatsApp */}
<button
  onClick={() => handleSocialClick('https://whatsapp.com/channel/0029Vb6POeTGE56dJATiYc2v')}
  className="group relative w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110"
  title="WhatsApp"
>
  <FaWhatsapp className="text-white text-xl transition-transform duration-300 group-hover:scale-110" />
</button>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default SocialMediaBar;